import { Component, Injector, AfterViewInit, inject, Input, ViewChild } from '@angular/core';
import { ABOUT_US, ADVOCATES, CANCEL, COMMON_MODULES, COMPREHENSIVE_SELECTION, CONTACT_US, EMPLOYERS, EMPLOYERS_QUOTATION, MARKETING_PRESELL_PAGE, PROFESSIONALS, PROFESSIONAL_BOOKED_APPOINTMENT, RESOURCES, ROUTES, SUCCESS, PHARMACY_LIST, PHARMACY_BRAND_DETAILS, APPOINTMENT_BOOKED_DETAIL, REQUEST_IMAGING_APPOINTMENT, REQUEST_SURGICAL_APPOINTMENT, VERIFY_PROFILE, PAYMENT, ACA_CONTENT, CEHAS_ACCESS_ACCOUNT, CEHAS, PROVIDER_APPOINTMENT_CONFIRMATION, OUR_POLICY } from '@src/app/core/constants';
import { ImageboxOneModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import { IMAGES_URL } from '@src/app/core/constants/system-list.constant';
import { Router } from '@angular/router';
import { TermsOfUseModalComponent } from '@src/app/core/shared/components/terms-of-use-modal/terms-of-use-modal.component';
import { PrivacyPolicyModalComponent } from '@src/app/core/shared/components/privacy-policy-modal/privacy-policy-modal.component';
import { SharedDataService } from '@src/app/core/services';
import { CoreClass } from '@src/app/core/base/core.class';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { employers_provider, providers, Linkedin } from '@src/app/core/constants';
import { Facebook, Instragram } from '@src/app/core/constants/system-list.constant';
import { ZohoChatbotService } from '@src/app/core/services/zoho-chatbot.service';
import { environment } from '@src/environments/environment';
declare var $: any;
// import * as $ from 'jquery';
@Component({
  selector: 'app-footer-one',
  standalone: true,
  templateUrl: './footer-one.component.html',
  styleUrls: ['./footer-one.component.scss'],
  imports: [...COMMON_MODULES, ImageboxOneModule, TermsOfUseModalComponent, PrivacyPolicyModalComponent],
})
export class FooterOneComponent extends CoreClass implements AfterViewInit {
  public routes = ROUTES;
  // activesection: string | null = null;
  employers_provider: string = employers_provider;
  providers: string = providers;
  Linkedin: string = Linkedin
  Instragram: string = Instragram;
  Facebook: string = Facebook;
  hasWellnessMembership : boolean = false;
  memberPortalOnly = environment.memberPortalOnly

  readonly appSectionhiddenRoutes: string[] = [
    CANCEL,
    SUCCESS,
    ADVOCATES,
    EMPLOYERS,
    EMPLOYERS_QUOTATION,
    PROFESSIONAL_BOOKED_APPOINTMENT,
    ABOUT_US,
    CONTACT_US,
    MARKETING_PRESELL_PAGE,
    RESOURCES,
    COMPREHENSIVE_SELECTION,
    PHARMACY_LIST,
    PHARMACY_BRAND_DETAILS,
    APPOINTMENT_BOOKED_DETAIL,
    REQUEST_IMAGING_APPOINTMENT,
    REQUEST_SURGICAL_APPOINTMENT,
    VERIFY_PROFILE,
    PAYMENT,
    ACA_CONTENT,
    CEHAS_ACCESS_ACCOUNT,
    PROVIDER_APPOINTMENT_CONFIRMATION,
    OUR_POLICY,
    'error'
   ];
  readonly appMaunehidesection: string[] = [
    EMPLOYERS_QUOTATION,
  ]
  readonly appMainSectionhiddenRoutes: string[] = [
    PHARMACY_LIST,
    PHARMACY_BRAND_DETAILS,
    REQUEST_IMAGING_APPOINTMENT,
    REQUEST_SURGICAL_APPOINTMENT,
    // CANCEL,
    VERIFY_PROFILE,
    ACA_CONTENT,
    CEHAS_ACCESS_ACCOUNT,
    PROVIDER_APPOINTMENT_CONFIRMATION,
    'error'
    // APPOINTMENT_BOOKED_DETAIL
  ];
  public route = inject(Router)
  @ViewChild(TermsOfUseModalComponent) termUseModalComp!: TermsOfUseModalComponent;
  @ViewChild(PrivacyPolicyModalComponent) privacyPolicyModalComp!: PrivacyPolicyModalComponent;

  constructor(
    protected injector: Injector,
    public override router: Router,
    private _route: ActivatedRoute,
    private zohoChatbotService: ZohoChatbotService
  ) {
    super(injector);
  }

  ngOnInit() {
    this.formembership('membership');
    this.hasWellnessMembership = localStorage.getItem('hasWellnessMembership') === 'true';
    
    this.zohoChatbotService.init();
    setTimeout(() => {
      this.zohoChatbotService.setUserCredentials();
    }, 2000);
  }

  currentYear: number = new Date().getFullYear();

  ngAfterViewInit() {
  }
  /**
   * Routes that keep the "use our app" section even inside the member portal. The
   * doctor listings are reached from a dashboard tile, which leaves `topbar` set to
   * MEMBERPORTAL — that alone used to hide the section, unlike the legacy PHP site.
   * Matched on the exact path so /professionals-detail is not affected.
   */
  readonly appSectionAlwaysShownRoutes: string[] = [PROFESSIONALS];

  // An empty link means this tenant has no app on that store.
  hasAppLinks: boolean = !!this.constantList.ANDROID_APP_LINK || !!this.constantList.IOS_APP_LINK;

  hideAppSection(): boolean {
    if (!this.hasAppLinks) {
      return true;
    }
    const path = this.router.url.split('?')[0].replace(/\/+$/, '');
    if (this.appSectionAlwaysShownRoutes.some(route => path === '/' + route)) {
      return false;
    }
    const hiddenRoutes = this.appSectionhiddenRoutes.some(path => this.router.url.includes(path));
    return hiddenRoutes || this.localStorageService.getDataInLocalStorage('topbar') == 'MEMBERPORTAL';
  }
  hideFooterMainSection(): boolean {
    const currentPath = this.router.url.split('?')[0].replace(/\/+$/, '');
    const hiddenRoutes = this.appMainSectionhiddenRoutes.some(path => currentPath.includes(path));
    return hiddenRoutes || this.localStorageService.getDataInLocalStorage('topbar') == 'MEMBERPORTAL'; 
  }
  hidemenue(): boolean {
    return this.appMaunehidesection.some(path => this.router.url.includes(path));

  }

  public setLanguage(event: any) {
    const ln = event?.target?.value?.toLowerCase();
    const lang = { code: ln };
    this.localStorageService.setDataInLocalStorage({ key: 'language', value: lang }, false);
    this.sharedService.setUserLanguage(lang);
    this.sharedService.setAppConfig();
    this.reloadCurrentRoute();
  }
  reloadCurrentRoute() {
    const currentUrl = this.router.url; this.router.navigateByUrl(ROUTES.resolver, { skipLocationChange: true }).then(() => { this.router.navigate([currentUrl]); });
  }
  openTermUseModal() {
    this.termUseModalComp.open();
  }

  openPrivacyPoliciesModal() {
    this.privacyPolicyModalComp.open();
  }
  activesection: string | null = null;
  innerlink = true;

  onclick(section: string) {
    this.activesection = this.activesection === section ? null : section;
    this.innerlink = true;
    console.log(this.innerlink, 'inner link');
    console.log(this.activesection, 'active section');
  }
  formembership(section: string) {
    this.activesection = this.activesection === section ? null : section;
    this.innerlink = true;
  }

  closeimg(event: any) {
    event.stopPropagation();
    this.activesection = null;
    this.innerlink = true;
    console.log(this.activesection, 'active section null');
    console.log(this.innerlink, 'inner link true');
  }

}
